export const logAuditAction = (actionName, actionDescription, moduleName) => {
    try {
        const userEmail = localStorage.getItem("user_cassia") || "Desconocido";
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        
        const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        
        const newLog = {
            id: Date.now() + Math.floor(Math.random() * 1000),
            user_name: userEmail,
            user_email: userEmail,
            summary: actionDescription,
            timestamp: timestamp,
            name_action: actionName,
            name_module: moduleName
        };
        
        const logs = JSON.parse(localStorage.getItem("auditLogs") || "[]");
        logs.unshift(newLog); // Agregar al inicio para que salgan primero los más recientes
        localStorage.setItem("auditLogs", JSON.stringify(logs));
    } catch(err) {
        console.error("Error logging audit action", err);
    }
}
